import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import TablePagination from 'components/table-pagination';

const Table = (props) => {
    return (
        <div className="card border-light shadow-sm mb-4">
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-centered table-nowrap mb-0 rounded">
                        {props.headers && props.headers.length > 0 &&
                            <thead className="thead-light">
                                <HeaderRow headers={props.headers} />
                            </thead>
                        }
                        {props.rows && props.rows.length > 0 &&
                            <tbody>
                                {props.rows.map((val, k) => {
                                    return <TableRow key={k} row={val} />
                                })}
                            </tbody>
                        }
                    </table>
                    {props.pagination &&
                        <TablePagination fetchList={props.fetchList} pagination={props.pagination} />
                    }
                </div>
            </div>
        </div>
    );
}

const HeaderRow = (props) => {
    return (
        <tr>
            {props.headers.map((val, k) => {
                return <HeaderCell key={k} columnNumber={k} text={val} />
            })}
        </tr>
    );
}

const HeaderCell = (props) => {
    let className = "border-0";
    if (props.columnNumber === 0) {
        className += " text-primary font-weight-bold";
    }

    return (
        <th className={className}>{props.text}</th>
    )
}

const TableRow = (props) => {
    return (
        <tr>
            {props.row.columns.map((val, k) => {
                return <TableCell key={k} columnNumber={k} text={val} tooltip={props.row.tooltips && props.row.tooltips[k]} cellLink={props.row.links && props.row.links[k]} rowLink={props.row.link} className={props.row.className} />
            })}
            {props.row.buttons && props.row.buttons.map((val, k) => {
                return <TableButton key={k} text={val} className={props.row.className} />
            })}
        </tr>
    );
}

const TableCell = (props) => {
    let className = props.className + " border-0";
    if (props.columnNumber === 0) {
        className += " text-primary font-weight-bold";
    }

    let cellValue = props.text;
    if (props.rowLink) {
        cellValue = <Link to={props.rowLink} data-bs-toggle={props.tooltip ? "tooltip" : null} data-bs-placement={props.tooltip ? "top" : null} title={props.tooltip}>{props.text}</Link>
    }

    return (
        <td className={className} data-bs-toggle={props.tooltip ? "tooltip" : null} data-bs-placement={props.tooltip ? "top" : null} title={props.tooltip} >
            {cellValue}
            {props.cellLink && <Link className="ms-2" to={props.cellLink}><FontAwesomeIcon icon={faExternalLinkAlt} /></Link>}
        </td>
    )
}

const TableButton = (props) => {
    let className = props.className + " border-0 p-1";
    return (
        <td className={className}>{props.text}</td>
    )
}

export default Table;
